import React from 'react';
import { Tag } from "antd";
import Text from "antd/lib/typography/Text";
import { camelCaseToTitle } from '../../../../../../../helpers/StringHelper';

export const filtersConfig = {
  type: 'modal',
  settings: {
    admLevel2: {
      label: 'Territory',
      type: 'text',
      placeholder: 'Type name of territory',
      options: [],
    },
    locationName: {
      type: 'text',
      label: 'Location',
      placeholder: 'Type name of location',
    },
    linkedStakeholderId: {
      type: 'select',
      label: 'Responsibility',
      placeholder: 'Select responsible party',
      optionsName: 'responsibles',
      options: [],
    },
    riskType: {
      label: 'Dashboard::Select risk type',
      type: 'select',
      options: [],
      // showIfHasValue: 'riskCategory',
    },
    typeOfMeasure: {
      // showIfHasValue: 'riskCategory',
      type: 'select',
      options: [],
      label: 'Measure Type',
      placeholder: 'Select measure type',
      optionsName: 'riskMeasures',
    },
    status: {
      type: 'select',
      label: 'Dashboard::Select Status',
      options: [
        { label: 'Completed', value: 'completed' },
        { label: 'In Progress', value: 'inProgress' },
        { label: 'Proposed', value: 'proposed' },
      ],
    },
  },
};

export const renderStatus = (t, record, notOneHunderdPercent = false) => (
  <Tag
    className="status-tag"
    style={{ width: !notOneHunderdPercent && '100%', textAlign: 'center' }}
    color={record === 'unplanned' ? 'default' : 'blue'}
  >
    <Text ellipsis={{ tooltip: true }}>
      {t(camelCaseToTitle(record))}
    </Text>
  </Tag>
);

export const renderObjective = (t, record) => (
  <Tag className="objective-tag" color={record === 'reduceVulnerability' ? 'blue' : 'default'}>
    <Text
      className="ellipsis-span"
      style={{ width: 'calc(100%)' }}
      ellipsis={{ tooltip: t(record) }}
    >
      {t(record)}
    </Text>
  </Tag>
);
